import { observer } from 'mobx-react-lite';
import { ComponentProps, ReactElement } from 'react';

export const TrashIcon = observer(
  (props: ComponentProps<'svg'>): ReactElement => (
    <svg
      {...props}
      xmlns='http://www.w3.org/2000/svg'
      fill='none'
      width='24'
      height='24'
      viewBox='0 0 24 24'
    >
      <g clipPath='url(#a)'>
        <path
          fill='currentColor'
          d='M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12ZM18 4h-2.5l-.71-.71c-.18-.18-.44-.29-.7-.29H9.91c-.26 0-.52.11-.7.29L8.5 4H6c-.55 0-1 .45-1 1s.45 1 1 1h12c.55 0 1-.45 1-1s-.45-1-1-1Z'
        />
      </g>
      <defs>
        <clipPath id='a'>
          <path
            fill='#fff'
            d='M0 0h24v24H0z'
          />
        </clipPath>
      </defs>
    </svg>
  )
);
